import { useCallback } from 'react';
import { useToggle } from 'react-use';
import { Content } from 'src/contexts/ContentContext';
import { useSiteTheme } from 'src/contexts/SiteTheme/SiteThemeContext';
import { vars } from 'src/core/themes';
import { Button, Tooltip } from 'src/core/ui';
import {
  ColumnSettingsModal,
  TableColumnsSectionType,
} from 'src/modals/ColumnSettings/ColumnSettings';
import { LayoutIcon } from 'src/svgs';
import {
  CustomEventsColumn,
  CustomOnSaleEventsColumn,
} from 'src/utils/columns/events/eventsCustomColumnUtils.types';
import { CustomListingColumn } from 'src/utils/columns/inventory/inventoryCustomColumnUtils.types';
import { CustomPurchasesColumn } from 'src/utils/columns/purchases/purchasesCustomColumnUtils.types';
import { CustomSalesColumn } from 'src/utils/columns/sales/salesCustomColumnUtils.types';
import { ContentId } from 'src/utils/constants/contentId';

import * as styles from '../EventHeader.css';

type EventHeaderTableColumnActionProps = {
  sectionType: TableColumnsSectionType;
};

export const EventHeaderTableColumnAction = <
  T extends
    | CustomOnSaleEventsColumn
    | CustomListingColumn
    | CustomSalesColumn
    | CustomEventsColumn
    | CustomPurchasesColumn,
>({
  sectionType,
}: EventHeaderTableColumnActionProps) => {
  const [isColumnModalOpen, toggleColumnModal] = useToggle(false);
  const { isDarkMode } = useSiteTheme();

  const onColumnSettingButtonClickHandler = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      e.stopPropagation();
      if (!isColumnModalOpen) toggleColumnModal(true);
    },
    [isColumnModalOpen, toggleColumnModal]
  );

  return (
    <>
      <Tooltip
        delayDuration={100}
        contentVariant={isDarkMode ? 'light' : 'dark'}
        align="center"
        triggerContent={
          <Button
            variant="outline"
            onClick={onColumnSettingButtonClickHandler}
            className={styles.actionButton}
          >
            <LayoutIcon size={vars.iconSize.l} />
          </Button>
        }
      >
        <Content id={ContentId.Columns} />
      </Tooltip>

      {isColumnModalOpen && (
        <ColumnSettingsModal<T>
          onClose={toggleColumnModal}
          sectionType={sectionType}
        />
      )}
    </>
  );
};
